import { Popover } from 'antd';
import PropTypes from 'prop-types';

export function PopoverWrapper({ children, title, content }) {
	return (
		<Popover
			showArrow={false}
			content={content}
			placement="bottomRight"
			title={title}
			trigger="hover"
			align={{ offset: [0, -10] }}
			overlayInnerStyle={{ border: '1px solid #C6C6C8' }}
		>
			{children}
		</Popover>
	);
}
PopoverWrapper.propTypes = {
	children: PropTypes.node,
	title: PropTypes.string,
	content: PropTypes.node,
};
